import React from "react";
import { arrayOf, func, shape, string } from "prop-types";

import InputWithLabel from "src/shared/components/Input/InputWithLabel";

import { validationSchema } from "../../utilities/validationSchema";

const AskAQuestion = ({
  formErrors,
  formValues: { question },
  inputError,
  onChange,
  setFormErrors,
  setSubmitting
}) => {
  const errorMessage = inputError("question");
  const validateInput = event => {
    if (validationSchema.fields.question.isValid(event.target.value)) {
      const errors = formErrors.filter(obj => obj.type !== "question_required");
      setFormErrors(errors);
    }
  };

  const handleChange = event => {
    onChange(event.target.value, event);
    validateInput(event);
    if (formErrors.length === 0) {
      setSubmitting(false);
    }
  };

  return (
    <InputWithLabel
      errorMessage={errorMessage}
      labelText="question"
      name="question"
      onChange={handleChange}
      required
      type="textarea"
      value={question}
    />
  );
};

AskAQuestion.propTypes = {
  formErrors: arrayOf(shape({ type: string, messages: arrayOf(string) })),
  setFormErrors: func,
  setSubmitting: func,
  formValues: shape({ question: string }).isRequired,
  onChange: func.isRequired,
  inputError: func.isRequired
};

AskAQuestion.defaultProps = {
  formErrors: [],
  setFormErrors: () => {},
  setSubmitting: () => {}
};

export default AskAQuestion;
